import { render, staticRenderFns } from "./addModule.vue?vue&type=template&id=ca3c005a"
import script from "./addModule.vue?vue&type=script&lang=js"
export * from "./addModule.vue?vue&type=script&lang=js"
import style0 from "./addModule.vue?vue&type=style&index=0&id=ca3c005a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports